import { ReactNode, useState } from "react"
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"

import { ImageUploadDropzone } from "./ImageUploadDropzone"

const useStyles = makeStyles()(() => ({
    accordion: {
        border: "1px solid #c4c4c4",
        height: "100%",
        width: "100%",
    },
    accordionDetails: {
        width: "100%",
    },
}))

type ImageUploadFieldProps = Readonly<{
    previewImage?: string
    label?: string
    onImageChange: (image: File | null) => void
    bottomContent?: ReactNode
}>

export function ImageUploadField({ label, onImageChange, previewImage, bottomContent }: ImageUploadFieldProps) {
    const { classes } = useStyles()
    const [isExpanded, setIsExpanded] = useState(true)

    return (
        <Accordion
            expanded={isExpanded}
            elevation={0}
            onChange={() => setIsExpanded(!isExpanded)}
            className={classes.accordion}
        >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                {label ? (
                    <Typography>{label}</Typography>
                ) : (
                    <LocalizedStrict id="image-uploader-button-label">
                        <Typography>Upload Image</Typography>
                    </LocalizedStrict>
                )}
            </AccordionSummary>
            <AccordionDetails className={classes.accordionDetails}>
                <ImageUploadDropzone
                    previewImage={previewImage}
                    onImageChange={onImageChange}
                    bottomContent={bottomContent}
                />
            </AccordionDetails>
        </Accordion>
    )
}
